module.exports = __webpack_public_path__ + "img/qilin-stage1-blink.389e7f40.png";